export default __webpack_public_path__ + "static/media/404-video.553339b7.mp4";